<template>
  <login-layout :title="getTitle">
    <Login
      v-show="active === 'login'"
      @redirectToModule="active = $event"
    />
    <ForgotPassword
      v-show="active === 'forgot'"
      @redirectToModule="active = $event"
    />
    <RePassword
      v-show="active === 'reset'"
      @redirectToModule="active = $event"
    />
  </login-layout>
</template>

<script>
import { getUrlKey } from '@/utils'
import Layout from './Layout'
import ForgotPassword from './components/ForgotPassword.vue'
import RePassword from './components/rePassword.vue'
import Login from './components/Login'
export default {
  name: 'SignIn',

  components: {
    'login-layout': Layout,
    ForgotPassword,
    Login,
    RePassword
  },

  data () {
    return {
      active: ''
    }
  },
  
  computed: {
    getTitle () {
      switch (this.active) {
        case 'login':
          return '登录'
        case 'reset':
          return '重置密码'
        case 'forgot':
          return '找回密码'
        default:
          return '登录'
      }
    }
  },

  methods: {},
  
  created () {
    if (getUrlKey('type') === 'reset') {
      this.active = 'reset'
    } else {
      this.active = 'login'
    }
  }
}
</script>

<style lang="scss">
/* 覆盖表单默认样式 */
.modern-login-form {
  .el-form-item {
    margin-bottom: 24px;
    
    &__content {
      line-height: 1;
    }
  }
}
</style>
